import React from "react";

import Header from "./components/Header";
import "./worklog.scss";
import Filters from "./components/Filters";
import History from "./components/History";
import { useResponsive } from "../../../hooks/useResponsive";

function Worklog() {
  const isMobile = useResponsive("down", "md");
  return (
    <>
      <Header />
      {!isMobile && <Filters />}
      <History />
    </>
  );
}

export default Worklog;
